import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import DynamicPage from './components/Pages/DynamicPage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function AppContent() {
  return (
    <div className="layout">
      <Header style={{gridArea: 'header'}}/>
      <main style={{gridArea: 'main'}}>
        <Routes>
          {/* Homepage route */}
          <Route path="/" element={<DynamicPage />} />

          {/* Catch-all route for other dynamic pages */}
          <Route path="/:slug" element={<DynamicPage />} />
        </Routes>
      </main>
      <Footer style={{gridArea: 'footer'}}/>
    </div>
  );
}

function App() {
  return <Router><AppContent /></Router>;
}

export default App;
